import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// const useStyles = makeStyles({
//   stopWatch: {
//     padding: '0 20px',
//     font-size: '1rem',
//     font-weight: '600',
//     color: '#FF6900',

//     }
// });
const useStyles = makeStyles({
  stopWatch: {
    padding: '0 20px',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#FF6900',
  },
});

export default function StopWatch(props: { reset?: boolean }) {
  const classes = useStyles();

  const { reset } = props;
  const [time, setTime] = useState(0);

  let tickRef: NodeJS.Timer;

  if (reset) {
    setTime(0);
  }

  const tick = () => {
    setTime(time + 1);
    console.log(time);
  };

  useEffect(() => {
    tickRef = setInterval(tick, 1000);
    return () => {
      clearInterval(tickRef);
    };
  });

  const display = () => {
    const hour = Number.parseInt((time / 60 / 60).toString());
    const min = Number.parseInt((time / 60).toString()) % 60;
    const sec = time % 60;

    const hh = ('0' + hour).substring(('0' + hour).length - 2);
    const mm = ('0' + min).substring(('0' + min).length - 2);
    const ss = ('0' + sec).substring(('0' + sec).length - 2);

    return `${hh}:${mm}:${ss}`;
  };

  return <span className={classes.stopWatch}>{display()}</span>;
}
